import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cx } from './cx.js';
import { Spinner } from './Spinner.js';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  /** `lg`/`xl` for till screens: bigger touch targets. */
  size?: 'md' | 'lg' | 'xl';
  /** Full width of its container. */
  block?: boolean;
  /** Shows a spinner and blocks clicks while an action runs. */
  loading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'primary',
    size = 'md',
    block = false,
    loading = false,
    disabled,
    type = 'button',
    className,
    children,
    ...rest
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx(
        'qk-btn',
        `qk-btn--${variant}`,
        `qk-btn--${size}`,
        block && 'qk-btn--block',
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <Spinner size="sm" label="Working" /> : null}
      <span className="qk-btn__label">{children}</span>
    </button>
  );
});
